import { useCallback } from 'react';

import useRequestJSON from './hooks/useRequestJSON';
import { PostJSON, BaseResponse } from './request';
import { AppKey } from './apps';
import { useTriagePatient } from '../contexts/triage/patient';
import { IsTriageAppEnded } from './schedule';

export interface IWaiver {
  id: number;
  name: AppKey;
  isConfirmed: boolean;
  isRevoked: boolean;
  patientId: number;
  contactId: number;
  isActive?: boolean;
}

export interface GetWaiversResponse extends BaseResponse {
  waivers: IWaiver[];
}

export interface GetWaiversResult {
  waivers: IWaiver[];
  isLoading: boolean;
}

export const useGetWaiversForPatient = (
  patientId: number
): GetWaiversResult => {
  const { patientData } = useTriagePatient();
  const request = useCallback(
    () =>
      PostJSON({
        url: '/waiver/data_for_patient/',
        params: {
          patientId
        }
      }),
    [patientId]
  );
  const { data, isLoading } = useRequestJSON<GetWaiversResponse>({
    request,
    enabled: patientId != null
  });
  const waivers = (data?.waivers || []).map((waiver) => {
    let isActive = true;
    if (patientData && patientData.apps && patientData.apps[waiver.name]) {
      const appEntry = patientData.apps[waiver.name];
      isActive = !IsTriageAppEnded(appEntry) && !appEntry.schedule?.isCanceled;
    }
    return {
      ...waiver,
      isActive
    };
  });
  return {
    waivers: waivers,
    isLoading
  };
};
